import { AsyncStoreItem } from '@lib';
import { PostBoardingPassesIssueHpbpResponse } from 'src/sdk_checkin';

/**
 * BoardingPassIssueHpbp model
 */
export interface BoardingPassIssueHpbpModel {
  model: PostBoardingPassesIssueHpbpResponse | null;
}

/**
 * PostBoardingPassesIssueHpbpResponse model details
 */
export interface BoardingPassIssueHpbpStateDetails extends AsyncStoreItem {}

/**
 * BoardingPassIssueHpbp store state
 */
export interface BoardingPassIssueHpbpState extends BoardingPassIssueHpbpStateDetails, BoardingPassIssueHpbpModel {}

/**
 * Name of the BoardingPassIssueHpbp Store
 */
export const BOARDING_PASS_ISSUE_HPBP_STORE_NAME = 'boardingPassIssueHpbp';

/**
 * BoardingPassIssueHpbp Store Interface
 */
export interface BoardingPassIssueHpbpStore {
  /** BoardingPassIssueHpbp state */
  [BOARDING_PASS_ISSUE_HPBP_STORE_NAME]: BoardingPassIssueHpbpState;
}
